import React from "react";
import {
  Link as RouterLink,
  LinkProps,
  useLocation,
} from "react-router-dom";
import { coerceRouterTo } from "./safeRouterTo";

/**
 * Drop-in Link that never passes "#" / missing `to` into React Router.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function SafeLink({ to, ...rest }, ref) {
    const { pathname } = useLocation();
    return (
      <RouterLink
        ref={ref}
        to={coerceRouterTo(to, pathname || "/")}
        {...rest}
      />
    );
  }
);

export default Link;
